// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yjEY3","col":"styles_col__1Szuw"};